import {Button, CardHeader, Grid, MenuItem, Paper, Table, TableBody, TableCell, TableHead, TableRow, TextField, Typography} from "@mui/material";
import {withStyles} from "@mui/styles";
import axios from "axios";
import * as React from "react";
import {Config} from "../../config/config";
import {Helpers} from "../../utils/helpers";
import {PopupMessage} from "../../utils/message";
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import StarIcon from '@mui/icons-material/Star';

const starDropdown = [
    {value: '', label: 'All'},
    {value: 0, label: <><StarIcon style={{color: 'gold'}} />x0</>},
    {value: 1, label: <><StarIcon style={{color: 'gold'}} />x1</>},
    {value: 2, label: <><StarIcon style={{color: 'gold'}} />x2</>},
    {value: 3, label: <><StarIcon style={{color: 'gold'}} />x3</>},
];

const victoryDropdown = [
    {value: 'All', label: 'All'},
    {value: 'Won', label: 'Won 🏆'},
    {value: 'Lost', label: 'Lost 🏳️'},
    {value: 'Draw', label: 'Draw 🤝'},
];

export class RubyWagerBattleReportMain extends React.Component<any, any> {
    constructor(props: any) {
        super(props);

        this.state = {
            loading: false,
            battles: [],
            totalWin: 0,
            totalLose: 0,
            userId: this.props.playerId,
            filter: {
                opponentId: '',
                type: 'All',
                stars: '',
                limit: 10,
                offset: 0,
                percent: ''
            }
        }
    }

    componentDidMount() {
        this.fetchData();
    }

    fetchData = async () => {
        const url = `${Config.getInstance.apiUrl}/api/ruby_wager_battle/`;

        this.setState({
            loading: true,
        });

        const headers = {
            Authorization: Helpers.getSessionId(),
        }

        const params = {
            ...this.state.filter,
            userId: this.state.userId,
        }

        const response = await axios.get(url, {
            params,
            headers
        });

        const data = response.data;
        const success = data.success;

        this.setState({
            loading: false,
        });

        if (success) {
            const battles = data.battles;
            const totalWin = data.totalWin;
            const totalLose = data.totalLose;

            this.setState({
                battles,
                totalWin,
                totalLose
            });
        } else {
            PopupMessage.error("Failed to fetch data")
        }
    }

    copyToClipboard(text: string) {
        navigator.clipboard.writeText(text);

        PopupMessage.success("Copied to clipboard");
    }

    onChangeFilter(key: string, value: any) {
        const {filter} = this.state;

        filter[key] = value;

        this.setState({filter});
    }

    onClearFilter = () => {
        const filter = {
            opponentId: '',
            type: 'All',
            stars: '',
            limit: 10,
            offset: 0,
            percent: ''
        }

        this.setState({filter});
    }

    renderOpponent = (opponent: any, opponentId: string) => {
        const user = opponent.user;
        const {name, squad_name} = user;

        return <Paper>
            <Grid container sm={12} spacing={1}>
                <Grid item container sm={10}>
                    <Grid item sm={12}>{name}</Grid>
                    <Grid item sm={12}>[{squad_name || 'No Squad'}]</Grid>
                </Grid>
                <Grid item sm={2}>
                    <ContentCopyIcon
                        onClick={() => this.copyToClipboard(JSON.stringify({
                            id: opponentId,
                            name,
                            squad: squad_name || 'No Squad'
                        }))}
                    />
                </Grid>
            </Grid>
        </Paper>
    }

    renderBattleResult = (battle: any) => {
        const {stars, percent, user} = battle;

        const uf = user.uf || 0;
        const score = user.score || 0;

        return (
            <Paper>
                <StarIcon style={stars > 0 ? {color: 'gold'} : {}} />
                <StarIcon style={stars > 1 ? {color: 'gold'} : {}} />
                <StarIcon style={stars > 2 ? {color: 'gold'} : {}} />
                <Typography>{percent}%</Typography>
                <ContentCopyIcon
                    onClick={() => this.copyToClipboard(JSON.stringify(battle))}
                />
                <Typography>{`Score: ${score}, UF: ${uf}`}</Typography>
            </Paper>
        )
    }

    renderContent() {
        if (this.state.loading) {
            return <TableRow key="loading-row">
                <TableCell colSpan={11}>
                    {Helpers.renderSkeletonRows(5, 50)}
                </TableCell>
            </TableRow>
        }

        const battles = this.state.battles;

        return <Table>
            <TableHead>
                <TableRow>
                    <TableCell>#</TableCell>
                    <TableCell style={{width: "5%"}}>ID</TableCell>
                    <TableCell>Wager</TableCell>
                    <TableCell>Fee</TableCell>
                    <TableCell>Result</TableCell>
                    <TableCell>Opponent</TableCell>
                    <TableCell>My Meta</TableCell>
                    <TableCell>Opponent Meta</TableCell>
                    <TableCell>Map Data</TableCell>
                    <TableCell>Time</TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                {
                    battles.map((battle: any, index: number) => {
                        let opponent = battle.winner_meta;
                        let opponentId = battle.winner_id;
                        const myResult = battle.winner_id === this.state.userId ? battle.winner_meta : battle.loser_meta;
                        const opponentResult = battle.winner_id === this.state.userId ? battle.loser_meta : battle.winner_meta;

                        let result = battle.winner_id === this.state.userId ? "Victory 🏆" : "Defeated 🏳️";
                        let color = battle.winner_id === this.state.userId ? "green" : "grey";
                        if (battle.is_draw) {
                            result = 'Draw 🤝';
                            color = 'orange';
                        }

                        if (this.state.userId === battle.winner_id) {
                            opponent = battle.loser_meta;
                            opponentId = battle.loser_id;
                        }

                        const date = new Date(battle.battle_time);

                        return <TableRow key={index}>
                            <TableCell>{index + 1}</TableCell>
                            <TableCell>{battle.id}</TableCell>
                            <TableCell>{battle.wager}</TableCell>
                            <TableCell>{battle.fee}</TableCell>
                            <TableCell>
                                <Typography variant='body1'>
                                    <span style={{color}}>{result}</span>
                                </Typography>
                            </TableCell>
                            <TableCell>{this.renderOpponent(opponent, opponentId)}</TableCell>
                            <TableCell>{this.renderBattleResult(myResult)}</TableCell>
                            <TableCell>{this.renderBattleResult(opponentResult)}</TableCell>
                            <TableCell>
                                {
                                    <ContentCopyIcon
                                        titleAccess="Copy Map Data"
                                        onClick={() => this.copyToClipboard(JSON.stringify(battle.defender_data))}
                                    />
                                }
                            </TableCell>
                            <TableCell>{date.toLocaleString('en-GB')}</TableCell>
                        </TableRow>
                    })
                }
            </TableBody>
        </Table>
    }

    renderFilter() {
        const style = {
            // height: '100px',
            padding: '10px',
            width: '100%',
            // backgroundColor: "black",
        } as React.CSSProperties;

        const {filter} = this.state;

        return <Paper style={style}>
            <Grid container sm={12} spacing={2} rowSpacing={2}>
                <Grid item sm={2}>
                    <TextField
                        label="Opponent ID..."
                        value={filter.attackerId}
                        onChange={(e) => this.onChangeFilter('opponentId', e.target.value)}
                        fullWidth
                        variant="outlined"
                    />
                </Grid>

                <Grid item sm={1.5}>
                    <TextField
                        label="Stars..."
                        value={filter.stars}
                        onChange={(e) => this.onChangeFilter('stars', e.target.value)}
                        fullWidth
                        variant="outlined"
                        select
                    >
                        {starDropdown.map((item, index) => {
                            return <MenuItem key={index} value={item.value}>{item.label}</MenuItem>
                        })}
                    </TextField>
                </Grid>

                <Grid item sm={1.5}>
                    <TextField
                        label="Result..."
                        value={filter.won}
                        onChange={(e) => this.onChangeFilter('type', e.target.value)}
                        fullWidth
                        variant="outlined"
                        select
                    >
                        {victoryDropdown.map((item, index) => {
                            return <MenuItem key={index} value={item.value}>{item.label}</MenuItem>
                        })}
                    </TextField>
                </Grid>

                {/* <Grid item sm={1}>
                    <TextField
                        label="Percent..."
                        value={filter.percent}
                        onChange={(e) => this.onChangeFilter('percent', e.target.value)}
                        fullWidth
                        variant="outlined"
                    />
                </Grid> */}
            </Grid>
            <Grid item container sm={12} spacing={2} justifyContent={"flex-end"}>
                <Grid item sm={1}>
                    <TextField
                        label="Limit..."
                        value={filter.limit}
                        onChange={(e) => this.onChangeFilter('limit', e.target.value)}
                        fullWidth
                        variant="outlined"
                        size="small"
                    />
                </Grid>
                <Grid item sm={1}>
                    <TextField
                        label="Offset..."
                        value={filter.offset}
                        onChange={(e) => this.onChangeFilter('offset', e.target.value)}
                        fullWidth
                        variant="outlined"
                        size="small"
                    />
                </Grid>

                <Grid item sm={1}>
                    <Button disableElevation fullWidth variant="contained" color="error" onClick={this.onClearFilter}>Clear</Button>
                </Grid>

                <Grid item sm={1}>
                    <Button disableElevation fullWidth variant="contained" color="primary" onClick={this.fetchData}>Search</Button>
                </Grid>

            </Grid>
        </Paper>
    }

    render() {
        const {classes} = this.props;
        return <Paper className="contentPadding">
            <Typography className={classes.paper} variant="h6">{`Ruby Wager Battle log for UID: ${this.state.userId}`}</Typography>
            {this.renderFilter()}
            {this.renderContent()}
        </Paper>
    }
}

const styles: any = () => ({
    paper: {
        padding: 8,
        backgroundColor: "black"
    },
});

export const PlayerRubyWager = withStyles(styles)(RubyWagerBattleReportMain);